import { Link, useLocation } from "react-router-dom";
import Avvvatars from "avvvatars-react";
import { useDispatch, useSelector } from "react-redux";
import {
  setDataLayout,
  setDataTheme,
} from "../../data/redux/themeSettingSlice";
import ImageWithBasePath from "../imageWithBasePath";
import {
  setExpandMenu,
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { useState } from "react";
import {
  prof_routes,
  parent_routes,
  student_routes,
  my_routes,
} from "../../../feature-module/router/all_routes";
import { useChildrenDetails } from "../context/ChildrenDetailsContext";
import { useAcademicYear } from "../context/AcademicYearContext";

// reducer pour se déconnecter
import { setLogout } from "../../data/redux/authSlice";
import { logout } from "../../../api/auth";

import AcademicYearSelect from "../AcademicYearSelect";
import NotificationHeader from "./notif_header";
import GlobalSearch from "../../../feature-module/search/GlobalSearch";
import { toast } from "sonner";

const Header = () => {
  const routes = my_routes;
  const dispatch = useDispatch();
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const [notificationVisible, setNotificationVisible] = useState(false);
  const [childrenListOpen, setChildrenListOpen] = useState(false);
  const userData = useSelector((state: any) => state.auth.user);
  const [setAvatar] = useState<any>(null);
  // type de l'utilisateure, ces permissions et les datas du sidebar
  const userType = useSelector((state: any) => state.auth.userType);

  //Initialisation des state utilisés
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar,
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  const onMouseEnter = () => {
    dispatch(setExpandMenu(true));
  };
  const onMouseLeave = () => {
    dispatch(setExpandMenu(false));
  };
  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      dispatch(setDataLayout("default_layout"));
      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const handleToggleClick = () => {
    if (dataTheme === "default_data_theme") {
      dispatch(setDataTheme("dark_data_theme"));
      // localStorage.setItem(dataTheme,"dark_data_theme")
    } else {
      dispatch(setDataTheme("default_data_theme"));
      // localStorage.removeItem(dataTheme)
    }
  };
  const location = useLocation();
  const { childrenDetails, selectedChild, setSelectedChild } =
    useChildrenDetails();
  const { selectedYear } = useAcademicYear();

  const currentChild =
    childrenDetails?.find((child: any) => child.id === selectedChild) ||
    childrenDetails?.[0];
  const hasYearInscription =
    !!currentChild &&
    !!selectedYear &&
    currentChild?.academicYear?.id === selectedYear?.id;

  const toggleNotification = () => {
    setNotificationVisible(!notificationVisible);
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => {});
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {});
        }
        setIsFullscreen(false);
      }
    }
  };

  return (
    <>
      {/* Header */}
      <div className="header">
        {/* Logo */}
        <div
          className="header-left active"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {userType === "ParentProfil" && currentChild ? (
            <Link
              to={parent_routes.parentDashboard}
              className="logo logo-normal d-flex justify-content-center text-center w-100"
            >
              <div className="d-flex align-items-center justify-content-center">
                {/* <div className="avatar avatar-md rounded me-2">
                  <Avvvatars
                    value={`${currentChild.firstname?.charAt(0) || ""}${currentChild.lastname?.charAt(0) || ""}`}
                    style="character"
                    size={40}
                  />
                </div> */}
                <div className="text-dark">
                  <div className="h6 mb-1">
                    {currentChild.firstname} {currentChild.lastname}
                  </div>
                  <div className="small">
                    {hasYearInscription
                      ? `${currentChild.class?.Level?.abbreviation || ""} - ${currentChild.class?.label || ""}`
                      : "Aucune inscription pour cette année"}
                  </div>
                </div>
              </div>
            </Link>
          ) : userType === "StudentProfil" ? (
            <Link
              to={student_routes.studentDashboard}
              className="logo logo-normal d-flex justify-content-center text-center w-100"
            >
              <div className="d-flex align-items-center justify-content-center">
                <div className="text-dark">
                  <div className="h6 mb-1">
                    {userData?.firstname} {userData?.lastname}
                  </div>
                  <div className="small">
                    {`${selectedYear?.Student?.Level?.abbreviation || ""} - ${selectedYear?.Student?.Class?.label || ""}`}
                  </div>
                </div>
              </div>
            </Link>
          ) : (
            <>
              <Link
                to={
                  userType === "StudentProfil"
                    ? student_routes.studentDashboard
                    : userType === "TeacherProfil"
                      ? prof_routes.teacherDashboard
                      : userType === "ParentProfil"
                        ? parent_routes.parentDashboard
                        : my_routes.adminDashboard
                }
                className="logo logo-normal"
              >
                <ImageWithBasePath src="assets/img/Logo-title.png" alt="Logo" />
              </Link>
              <Link
                to={
                  userType === "StudentProfil"
                    ? student_routes.studentDashboard
                    : userType === "TeacherProfil"
                      ? prof_routes.teacherDashboard
                      : userType === "ParentProfil"
                        ? parent_routes.parentDashboard
                        : my_routes.adminDashboard
                }
                className="logo-small"
              >
                <ImageWithBasePath
                  src="assets/img/Logo-Campus.png"
                  alt="Logo"
                />
              </Link>
              <Link
                to={
                  userType === "StudentProfil"
                    ? student_routes.studentDashboard
                    : userType === "TeacherProfil"
                      ? prof_routes.teacherDashboard
                      : userType === "ParentProfil"
                        ? parent_routes.parentDashboard
                        : my_routes.adminDashboard
                }
                className="dark-logo"
              >
                <ImageWithBasePath
                  src="assets/img/logo-title-dark.png"
                  alt="Logo"
                />
              </Link>
            </>
          )}
          <Link id="toggle_btn" to="#" onClick={handleToggleMiniSidebar}>
            <i className="ti ti-menu-deep" />
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#sidebar"
          onClick={toggleMobileSidebar}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        <div className="header-user">
          <div className="nav user-menu">
            {/* Search */}

            <div className="nav-item nav-search-inputs me-auto">
              {userType === "UserProfil" && <GlobalSearch />}
            </div>
            {/* /Search */}
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center">
                <AcademicYearSelect className="me-2 d-block d-sm-inline-block" />
                {/* autres boutons */}
              </div>
              {/* Notification */}
              <Link
                onClick={toggleNotification}
                to="#"
                className="btn btn-outline-light bg-white btn-icon position-relative me-1"
                id="notification_popup"
              >
                <i className="ti ti-bell" />
                <span className="notification-status-dot" />
              </Link>

              {/* /Notification */}
              <div className="pe-1">
                <Link
                  onClick={toggleFullscreen}
                  to="#"
                  className="btn btn-outline-light bg-white btn-icon me-1"
                  id="btnFullscreen"
                >
                  <i className="ti ti-maximize" />
                </Link>
              </div>
              <div className="pe-1">
                {!location.pathname.includes("layout-dark") && (
                  <Link
                    onClick={handleToggleClick}
                    to="#"
                    id="dark-mode-toggle"
                    className="dark-mode-toggle activate btn btn-outline-light bg-white btn-icon me-1"
                  >
                    <i
                      className={
                        dataTheme === "default_data_theme"
                          ? "ti ti-moon"
                          : "ti ti-brightness-up"
                      }
                    />
                  </Link>
                )}
              </div>
              <div className="dropdown ms-1">
                <Link
                  to="#"
                  className="dropdown-toggle d-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <span className="avatar avatar-md rounded">
                    <Avvvatars
                      value={`${userData.firstname?.charAt(0) || ""}${
                        userData.lastname?.charAt(0) || ""
                      }`}
                      style="character" // ou "character"
                    />
                  </span>
                </Link>
                <div className="dropdown-menu">
                  <div className="d-block">
                    <div className="d-flex align-items-center p-2">
                      <span className="avatar avatar-md me-2 online avatar-rounded">
                        <Avvvatars
                          value={`${userData.firstname?.charAt(0) || ""}${
                            userData.lastname?.charAt(0) || ""
                          }`}
                          style="character" // ou "character"
                        />
                      </span>
                      <div>
                        <h6>{`${userData?.firstname} ${userData?.lastname}`}</h6>
                        <p className="text-primary mb-0">
                          {userData?.jobFunction}
                        </p>
                      </div>
                    </div>
                    <hr className="m-0" />
                    <Link
                      className="dropdown-item d-inline-flex align-items-center p-2"
                      to={my_routes.profile}
                    >
                      <i className="ti ti-user-circle me-2" />
                      Mon Profil
                    </Link>
                    <hr className="m-0" />
                    <button
                      className="dropdown-item d-inline-flex align-items-center p-2"
                      onClick={toggleNotification}
                    >
                      <i className="ti ti-bell me-2" />
                      Notifications
                    </button>
                    <hr className="m-0" />
                    <button
                      className="dropdown-item d-inline-flex align-items-center p-2"
                      // to={my_routes.login}
                      // reloadDocument
                      onClick={async () => {
                        try {
                          await logout();
                          dispatch(setLogout());
                          window.location.href = "/";
                        } catch (error) {
                          // console.log(
                          //   "problème lors de la déconnexion !: ",
                          //   error,
                          // );
                          toast.error("problème lors de la déconnexion");
                        }
                      }}
                    >
                      <i className="ti ti-login me-2" />
                      Déconnexion
                    </button>
                    {userType === "ParentProfil" &&
                      childrenDetails &&
                      childrenDetails.length > 0 && (
                        <>
                          <hr className="m-0" />
                          <div className="p-2">
                            <button
                              type="button"
                              className="dropdown-item d-flex align-items-center justify-content-between p-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                setChildrenListOpen((open) => !open);
                              }}
                            >
                              <span>Sélectionner un enfant</span>
                              <i
                                className={
                                  childrenListOpen
                                    ? "ti ti-chevron-up"
                                    : "ti ti-chevron-down"
                                }
                              />
                            </button>
                            {childrenListOpen && (
                              <div className="mt-2">
                                {childrenDetails.map((child: any) => (
                                  <button
                                    key={child.id}
                                    type="button"
                                    className={`dropdown-item d-flex align-items-center p-2 ${
                                      selectedChild === child.id ? "active" : ""
                                    }`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedChild(child.id);
                                    }}
                                  >
                                    {selectedChild === child.id && (
                                      <i className="ti ti-check me-2" />
                                    )}
                                    {child.firstname} {child.lastname}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            <Link className="dropdown-item" to={routes.profile}>
              Mon Profile
            </Link>
            <Link
              className="dropdown-item"
              to={"#"}
              onClick={toggleNotification}
            >
              Notifications
            </Link>
            <Link
              className="dropdown-item"
              to={"/"}
              onClick={async () => {
                try {
                  await logout();
                  dispatch(setLogout());
                  window.location.href = "/";
                } catch (error) {
                  alert(error);
                }
              }}
            >
              Déconnexion
            </Link>
            {userType === "ParentProfil" &&
              childrenDetails &&
              childrenDetails.length > 0 && (
                <>
                  <hr className="m-0" />
                  <div className="p-0">
                    <button
                      type="button"
                      className=" bg-light dropdown-item d-flex align-items-center justify-content-between p-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        setChildrenListOpen((open) => !open);
                      }}
                    >
                      <span>Sélectionner un enfant</span>
                      <i
                        className={
                          childrenListOpen
                            ? "ti ti-chevron-up"
                            : "ti ti-chevron-down"
                        }
                      />
                    </button>
                    {childrenListOpen && (
                      <div className="mt-0">
                        {childrenDetails.map((child: any) => (
                          <button
                            key={child.id}
                            type="button"
                            className={`dropdown-item d-flex align-items-center ${
                              selectedChild === child.id ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedChild(child.id);
                            }}
                          >
                            {selectedChild === child.id && (
                              <i className="ti ti-check me-2" />
                            )}
                            {child.firstname} {child.lastname}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </>
              )}
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
      {/* /Header */}
      <NotificationHeader
        notificationVisible={notificationVisible}
        toggleNotification={toggleNotification}
      />
    </>
  );
};

export default Header;
